import React from 'react';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import { ContributePageConsumer } from '../context';
import ContributeConfirm from './contribute-confirm';

const GET_CAMPAIGN = gql`
    query CampaignById($id: ID!) {
        campaign: campaignById(id: $id) {
            id
            name
            stats {
                performanceRemaining
                performanceEstimatedTotal
            }
            thirdPartyTerms {
                statement
                extended
            }
        }
    }
`;

const GET_FUNDRAISER = gql`
    query FundraiserByUsername($campaign: ID!, $username: String!) {
        fundraiser: fundraiserByUsername(campaignId: $campaign, username: $username) {
            id
            user {
                id
                firstName
                lastName
                email
                avatar {
                    id
                }
            }
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        context: <ContributePageConsumer />,
        campaignQuery: ({ render, context }) => (
            <Query query={GET_CAMPAIGN} variables={{ id: context.campaign.id }}>
                {render}
            </Query>
        ),
        fundraiserQuery: ({ render, context }) => (
            <Query
                skip={!context.contribution.fundraiser}
                query={GET_FUNDRAISER}
                variables={{
                    campaign: context.campaign.id,
                    username: context.contribution.fundraiser,
                }}
            >
                {render}
            </Query>
        ),
    },
    ({ context, campaignQuery, fundraiserQuery }) => ({
        error: campaignQuery.error || fundraiserQuery.error,
        loading: campaignQuery.loading || fundraiserQuery.loading,
        campaign: get(campaignQuery, 'data.campaign'),
        fundraiser: get(fundraiserQuery, 'data.fundraiser'),
        contribution: context.contribution,
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

export default props => (
    <Wrapper>
        {({ error, loading, campaign, fundraiser, contribution }) => {
            if (error) throw error;
            if (loading) return null;

            return <ContributeConfirm {...{ campaign, fundraiser, contribution, ...props }} />;
        }}
    </Wrapper>
);
